<script>
import Layout from '@layouts/adminLayout.vue'

export default {
  page: {
    title: 'Loading page...',
    meta: [{ name: 'description', content: 'Loading page...' }],
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <Transition appear>
      <BaseIcon name="spinner" spin />
    </Transition>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
